import style from './BlockList.module.scss';

import { BlockItem } from './BlockItem';

export interface BlockListProps {}

interface Props extends BlockListProps {
    blockIndexes: number[];
}

export function BlockList({ blockIndexes }: Props) {
    return (
        <div className={style.root}>
            {blockIndexes.map(index => (
                <div
                    key={index}
                    className={style.blockItem}
                >
                    <BlockItem blockIndex={index} />
                </div>
            ))}
        </div>
    );
}
